import React, { Component } from "react";
import { Modal, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changePassword } from "../../actions/getAgentConfig";
import { logData } from "../../utils/utils";
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      showErr: false,
      showChangePasswordModal: props.showChangePasswordModal,
      oldPass: "",
      newPass: "",
      confirmNewPass: "",
      passwordStrength: "",
    };
  }

  handleEnter = () => {
    this.setState({
      oldPass: "",
      newPass: "",
      confirmNewPass: "",
      passwordStrength: "",
    });
  };

  close = (key) => {
    this.setState(
      {
        showErr: false,
      },
      () => {
        this.props.handleClose(key);
      }
    );
  };

  // closes alert
  handleAlertDismiss = () => {
    this.setState({
      showErr: false,
    });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
   // const passwordStrength = this.getPasswordStrengthLevel(value);

    this.setState({
      [name]: value,
     // passwordStrength: passwordStrength,
    });
  };

  handleChangeNewPassword = (event) => {
    const { name, value } = event.target;
    const passwordStrength = this.getPasswordStrengthLevel(value);

    this.setState({
      [name]: value,
      passwordStrength: passwordStrength,
    });
  };


  // updates new selected language
  handleSubmit = () => {
    const { oldPass, newPass, confirmNewPass } = this.state;
    const { translations, selectedLanguage } = this.props;

    if (
      oldPass.length === 0 ||
      newPass.length === 0 ||
      confirmNewPass.length === 0
    ) {
      this.setState({
        errorMsg: translations.allFieldsRequired[selectedLanguage],
        showErr: true,
      });
    } else if (newPass !== confirmNewPass) {
      this.setState({
        errorMsg: translations.passShouldMatch[selectedLanguage],
        showErr: true,
      });
    } else if (newPass.length < 8) {
      this.setState({
        errorMsg: translations.passwordMinLengthError[selectedLanguage],
        showErr: true,
      });
    } else {
      // Makes API call from action
      this.props.changePassword(this.state).then(
        (res) => {
          if (res.data.result) {
            this.setState(
              {
                showErr: false,
              },
              () => {
                this.props.handleClose(this.props.showChangePasswordModal);
              }
            );
          } else {
            this.setState({
              errorMsg:
                res.data.description ||
                translations.passChangeError[selectedLanguage],
              showErr: true,
            });
          }
        },
        (err) => {
          logData(err);
          this.setState({
            errorMsg: translations.passChangeError[selectedLanguage],
            showErr: true,
          });
        }
      );
    }
  };

  getPasswordStrengthLevel = (password) => {
    const { translations, selectedLanguage } = this.props;
    if (password.length >= 8) {
      const containsUppercase = /[A-Z]/.test(password);
      const containsLowercase = /[a-z]/.test(password);
      const containsNumber = /[0-9]/.test(password);
      const containsSpecialCharacter =
        /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);

      let strengthLevel =
        containsUppercase +
        containsLowercase +
        containsNumber +
        containsSpecialCharacter;

      let cases = document.getElementById("password-case");
      if (!containsLowercase || !containsUppercase) {
        cases.style.display = "block";
      } else {
        cases.style.display = "none";
      }
      let numeric = document.getElementById("password-numeric");
      if (!containsNumber) {
        numeric.style.display = "block";
      } else {
        numeric.style.display = "none";
      }
      let symbol = document.getElementById("password-symbol");
      if (!containsSpecialCharacter) {
        symbol.style.display = "block";
      } else {
        symbol.style.display = "none";
      }

      const strenght = document.getElementById("password-strength");

      if (strengthLevel === 4) {
        strenght.style.color = "#71865E";
        return translations.passwordStrong[selectedLanguage];
      } else if (strengthLevel >= 2) {
        strenght.style.color = "#F4B400";
        return translations.passwordMedium[selectedLanguage];
      } else {
        strenght.style.color = "#E64759";
        return translations.passwordWeak[selectedLanguage];
      }
    } else {
      const strenght = document.getElementById("password-strength");
      strenght.style.color = "#E64759";
      return translations.passLessChars[selectedLanguage];
    }
  };

  render() {
    const { translations, selectedLanguage } = this.props;
    const { passwordStrength } = this.state;
    return (
      <Modal
        show={this.props.showChangePasswordModal}
        onEnter={this.handleEnter}
        onHide={() => this.close("showChangePasswordModal")}
        backdrop="static"
      >
        <Modal.Header
          className={`modal-content${this.props.theme} modal-header${this.props.theme}`}
          closeButton
        >
          <Modal.Title>
            {translations.changePassword[selectedLanguage]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {this.state.showErr && (
            <div className="alertWrapper">
              <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                <p>{this.state.errorMsg}</p>
              </Alert>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <div className="form-group required">
                <label htmlFor="oldPass" className="control-label">
                  {translations.oldPass[selectedLanguage]}
                </label>
                <input
                  name="oldPass"
                  type="password"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  id="oldPass"
                   onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group required">
                <label htmlFor="newPass" className="control-label">
                  {translations.newPass[selectedLanguage]}
                </label>
                <input
                  name="newPass"
                  type="password"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  id="newPass"
                  onChange={this.handleChangeNewPassword}
                />
                  
                    <div id="password-strength" className="password-strength">
                      {passwordStrength}
                    </div>
                {this.state.newPass.length > 0 && (
                  <div>
                    <ul>
                      <li id="password-case" style={{ display: "none" }}>
                      {translations.validationCaseType[selectedLanguage]}
                      </li>
                      <li id="password-numeric" style={{ display: "none" }}>
                      {translations.validationNumerical[selectedLanguage]}
                      </li>
                      <li id="password-symbol" style={{ display: "none" }}>
                      {translations.calidationSymbol[selectedLanguage]}
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group required">
                <label htmlFor="confirmNewPass" className="control-label">
                  {translations.confirmNewPass[selectedLanguage]}
                </label>
                <input
                  name="confirmNewPass"
                  type="password"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  id="confirmNewPass"
                   onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close("showChangePasswordModal")}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
          >
            {translations.cancel[selectedLanguage]}
          </button>
          <button
            type="submit"
            onClick={this.handleSubmit}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
          >
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    agentInfo: state.agentInfo,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changePassword }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/agent/modals/ChangePassword.js